import { useState } from 'react';

export function useStickerPicker() {
  const [selectedStickerPackId, setSelectedStickerPackId] = useState('');

  return {
    selectedStickerPackId,
    setSelectedStickerPackId,
  };
}
